// This icon file is generated automatically.
var DashOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z"
      }
    }]
  },
  "name": "dash",
  "theme": "outlined"
};
export default DashOutlined;